import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { BRAND } from "../lib/brand";

const WhatsAppButton = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setShow(true), 700);
        return () => clearTimeout(t);
    }, []);

    const handleClick = (e) => {
        e.preventDefault();
        const url = `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(
            "Hola Dr. Cárdenas, me gustaría agendar una consulta."
        )}`;

        // Try opening WhatsApp in a new tab.  If the host environment blocks
        // popups (some iframed previews), fall back to copying the phone
        // number so the user can still reach the doctor.
        try {
            const win = window.open(url, "_blank", "noopener,noreferrer");
            if (!win || win.closed || typeof win.closed === "undefined") {
                throw new Error("popup-blocked");
            }
        } catch (err) {
            navigator.clipboard
                ?.writeText(BRAND.whatsappDisplay)
                .catch(() => {});
            toast.message("WhatsApp no se abrió en este navegador", {
                description: `Copiamos el número al portapapeles: ${BRAND.whatsappDisplay}`,
                duration: 6000,
            });
        }
    };

    return (
        <a
            data-testid="whatsapp-floating-button"
            href={`https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(
                "Hola Dr. Cárdenas, me gustaría agendar una consulta."
            )}`}
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escríbenos por WhatsApp"
            className={`group fixed bottom-6 right-6 z-50 transition-all duration-700 ${
                show
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-4 pointer-events-none"
            }`}
        >
            <span className="absolute right-full top-1/2 -translate-y-1/2 mr-3 whitespace-nowrap px-4 py-2 bg-navy text-cream text-[11px] tracking-[0.2em] uppercase opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 border border-gold/30">
                Escríbenos directo
            </span>

            <span className="relative flex items-center justify-center w-14 h-14 bg-navy text-gold border border-gold/40 hover:bg-gold hover:text-navy transition-all duration-300 shadow-[0_8px_28px_rgba(13,31,78,0.35)]">
                <MessageCircle size={22} strokeWidth={1.6} />
                <span className="absolute inset-0 border border-gold/50 animate-ping opacity-40" />
            </span>
        </a>
    );
};

export default WhatsAppButton;
